module.exports = __webpack_public_path__ + "static/media/new-new-keras.7b4e5392.svg";